import React from 'react';
import styled from 'styled-components';
import Navigation from '../components/layout/Navigation';
import PhotocardsSection from '../components/sections/PhotocardsSection';

const Photocards: React.FC = () => {
  return (
    <PhotocardsContainer>
      <Navigation />
      <PhotocardsContent>
        <PhotocardsSection />
      </PhotocardsContent>
    </PhotocardsContainer>
  );
};

const PhotocardsContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;

const PhotocardsContent = styled.div`
  padding-top: 6rem;
`;

export default Photocards; 